import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import {
  ContainerFileDropCallable,
  type ContainerFileDropCallableProps,
} from "@/action-dialog/callables/ContainerFileDropCallable";
import {
  CrossWorkspaceFileDropCallable,
  type CrossWorkspaceFileDropCallableProps,
} from "@/action-dialog/callables/CrossWorkspaceFileDropCallable";
import type { ContainerFileDropChoice } from "@/action-dialog/dialogs/ContainerFileDropDialog";
import type { CrossWorkspaceFileDropChoice } from "@/action-dialog/dialogs/CrossWorkspaceFileDropDialog";

export type { ContainerFileDropChoice } from "@/action-dialog/dialogs/ContainerFileDropDialog";
export type { CrossWorkspaceFileDropChoice } from "@/action-dialog/dialogs/CrossWorkspaceFileDropDialog";

/**
 * Interception for canvas/chat files dropped into another container:
 * "Add to workspace & add here" (routine) vs "Add a copy" (explicit).
 * Resolves null when dismissed — the drop is abandoned.
 */
export function runContainerFileDropWorkflow(
  params: ContainerFileDropCallableProps,
): Promise<ContainerFileDropChoice | null> {
  return withActionDialogLock(() => ContainerFileDropCallable.call(params));
}

/**
 * The cross-workspace fork for workspace files: copy (default) vs labeled
 * live reference. Resolves null when dismissed.
 */
export function runCrossWorkspaceFileDropWorkflow(
  params: CrossWorkspaceFileDropCallableProps,
): Promise<CrossWorkspaceFileDropChoice | null> {
  return withActionDialogLock(() =>
    CrossWorkspaceFileDropCallable.call(params),
  );
}
